export const walletType = (
  theme: any,
  checked?: boolean,
  isNotClickable?: boolean,
  fromConnect?: boolean
) => {
  return {
    backgroundColor:
      checked === false ? '#808080' : theme.colors.backgroundPrimary,
    borderRadius: theme.sizing.scale300,
    height: '96px',
    ...(fromConnect && { width: '150px' }),
    marginTop: theme.sizing.scale800,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    cursor: checked ? 'pointer' : 'default',
    ':hover': {
      boxShadow: `${
        isNotClickable
          ? ''
          : `0px 0px 8px ${theme.colors.primary}, 0px 0px 4px ${theme.colors.primary}`
      } `,
      background: `${
        isNotClickable
          ? theme.colors.backgroundPrimary
          : theme.colors.backgroundTertiary
      }`,
    },
  };
};

export const walletTypeIcon = (theme: any) => {
  return {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: theme.sizing.scale400,
  };
};

export const walletTypeLabel = (theme: any, checked?: boolean) => {
  return {
    textAlign: 'center',
    ...theme.typography.font250,
    color: checked === false ? 'rgba(0, 0, 0, 0.25)' : theme.colors.white,
    fontWeight: '400',
  };
};

export const walletTypeCss = (
  checked?: boolean,
  isNotClickable?: boolean,
  fromConnect?: boolean
) => {
  return `
    flex flex-col justify-center rounded-lg h-24 ${fromConnect ? 'w-36' : ''} ${
      checked
        ? 'bg-backgroundDark-secondary cursor-pointer'
        : 'cursor-default bg-grey-1000'
    } hover:bg-backgroundDark-secondary ${
      isNotClickable ? '' : 'shadow-primary shadow-3xl'
    }
  `;
};
